import { IconProps } from "./types";
import React from "react";

export const TagIcon = ({
  className,
  fill = "currentColor",
  width = 10,
  height = 11,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 10 11"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M9.69709 5.28803L5.20028 0.790276C5.01313 0.603926 4.75977 0.499529 4.49581 0.500002H0.996413C0.732632 0.501572 0.4801 0.60717 0.293576 0.793899C0.107051 0.980629 0.00156861 1.23344 0 1.49751V4.99875C0.000283515 5.13107 0.0268587 5.262 0.0781783 5.38393C0.129498 5.50587 0.204536 5.61636 0.298924 5.70898L4.79474 10.2097C4.98188 10.3961 5.23524 10.5005 5.4992 10.5C5.6307 10.5002 5.76088 10.4738 5.88194 10.4223C6.00299 10.3709 6.11242 10.2955 6.20367 10.2007L9.70108 6.6995C9.79577 6.60816 9.87106 6.4986 9.92242 6.37742C9.97379 6.25623 10.0002 6.12591 10 5.99426C9.99589 5.7281 9.88704 5.47431 9.69709 5.28803ZM1.7487 2.99377C1.60051 2.99377 1.45564 2.94977 1.33241 2.86735C1.20919 2.78492 1.11315 2.66777 1.05644 2.5307C0.999726 2.39364 0.984888 2.24281 1.0138 2.0973C1.04271 1.95179 1.11408 1.81813 1.21887 1.71322C1.32366 1.60832 1.45717 1.53687 1.60252 1.50793C1.74787 1.47899 1.89853 1.49384 2.03545 1.55062C2.17237 1.60739 2.28939 1.70354 2.37173 1.8269C2.45406 1.95025 2.49801 2.09528 2.49801 2.24364C2.49906 2.34277 2.48045 2.44113 2.44326 2.533C2.40606 2.62488 2.35102 2.70845 2.28132 2.77888C2.21162 2.8493 2.12866 2.90517 2.03723 2.94326C1.9458 2.98135 1.84773 3.00089 1.7487 3.00075V2.99377Z"
      fill={fill}
    />
  </svg>
);
